import { useParams } from "react-router-dom";
import Header from "../components/Header/Header";
import Box from '@mui/material/Box';
import PerformanceEvaluationQualification from "../components/PerformanceEvaluationQualification/PerformanceEvaluationQualification";
import { capitalizeFirstLetter } from "../helpers/CapitalizeFirstLetter";




const PerformanceEvaluationQualificationScreen = () => {
  const { typeUser,token } = useParams<{ typeUser: string; token: string }>();
  let type= typeUser==='lider'?'Líder' :capitalizeFirstLetter(typeUser)    
  return (
    <div className="scrolledQual">
    <Header fromLink />
    <div style={{
      backgroundColor: "#F5F6F9",
      minHeight: "calc(100vh - 74px)",
      padding: '50px 50px 0px 50px'
    }}>
      <Box mt={1} ml={5} className="Title" mb={1}>
        Evaluación de desempeño
      </Box>
       <Box mt={1} ml={5} className="Title" mb={1}>{type} </Box>      
      <div>        
        <PerformanceEvaluationQualification 
        typeUser={typeUser}
        token={token}/>
      </div>
    </div>
  </div>
  )
}

export default PerformanceEvaluationQualificationScreen